import { connect } from "react-redux";
import { commonSlice, userSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import { PageMyProfile } from "senac-components";
import { PageMyProfileDispatchProps, Profile } from "senac-components/dist/pages/Mobile/PageMyProfile";
import { PageMyProfileWeb, PageMyProfileDispatchProps as PageMyProfileDispatchWebProps } from "senac-components/dist/pages/Web/PageMyProfile";
import { MenuOptions, PageHeaderOptionItem } from "senac-components/dist/pages/Mobile/PageInterfaces";
import { updatingUser } from "../store/reducers/userSlice";
import Sdk from "api.digitalpages.module.sdk.api";


const mapState = (state: RootState) => 
{
  const organization = (state.userState.organizations?.find(item => item.migrated) ?? {}).name ?? 
  Sdk.Api.authorization.activeProject?.directory?.name ?? 'Minha organização'

  const privacy = (state.userState.preferences ?? []).find((item: any) => item.key === 'accepted_privacy_police')
  const result:Profile & { organization?: any, acceptedPrivacyPolice?: any, userOrganizations?: any[] } = {
    uid : state.userState.user?.uid,
    email : state.userState.user?.email,
    login : state.userState.user?.login,
    name : state.userState.user?.name,
    cpf: state.userState.user?.cpf,
    phone : state.userState.user?.phone,
    organization,
    acceptedPrivacyPolice: Boolean(privacy),
    userOrganizations: state.userState.projects ?? [],
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => 
{
  const result: PageMyProfileDispatchProps & Partial<PageMyProfileDispatchWebProps> = 
  {
    onClickOrganizationMigrated: () => dispatch(userSlice.actions.showMyProjects()),
    onClickLinkOrganization: () => dispatch(userSlice.actions.syncOrganization()),
    onClickLogout : () => dispatch(userSlice.actions.logout()),
    onClickBack : () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: PageHeaderOptionItem) =>
     dispatch(commonSlice.actions.goToMyProfileOption(option)),
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onClickUpdateProfile: (profile: Profile)=> dispatch(updatingUser(profile)),
    onSelectedNavigationPageOption: (option:MenuOptions) => dispatch(commonSlice.actions.goToPage(option)),
    onClickChangePassword: () => dispatch(commonSlice.actions.changePage()),
  };
  return result;
};

const WPageProfile = () => {
  const Mobile = connect(mapState, mapDispatch)(PageMyProfile);
  const Web = connect(mapState, mapDispatch)(PageMyProfileWeb);
  if(window.innerWidth < 1024) return <Mobile />
  return <Web />
}

export { WPageProfile };
